import { Backdrop, Box, Button, CircularProgress, Dialog, IconButton, MenuItem, Stack, TextField, Typography } from "@mui/material";
import React, { useContext, useMemo, useState } from "react";
import { API } from "../conf";
import { Context, theme } from "../App";
import { alert_types, banques } from "../asset/variables";
import { ArrowDownward, Close, Delete, Edit, Replay } from "@mui/icons-material";

function EspecesItem(props) {
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('') 
    const [count, setCount] = useState(props.count)

    function manage_dialog(open, action) {
        setOpen(open)
        setAction(open?action:'')
    }

    return <Box>
        {props.especesUpdates.some(es=>es.montant===props.montant&&es.updatedCount<=0)?
        <Stack direction='row' alignItems='center' sx={{backgroundColor: 'carmine.background', borderRadius:3, padding:2}}>
            <Typography marginRight={1}>{props.count} x {props.montant.toFixed(2)}€</Typography>
            <IconButton aria-label="supprimer" onClick={props.deleteUpdate}><Replay fontSize="small"/></IconButton>
        </Stack>
        :<Stack direction='column' alignItems='center' sx={{border:'solid transparent 1px', backgroundColor: 'primary.background', borderRadius:3, padding:2}}>
            <Stack direction='row' alignItems='center'>
                <Typography marginRight={1}>{props.count} x {props.montant.toFixed(2)}€</Typography>
                <IconButton aria-label="modifier" onClick={()=>manage_dialog(true, 'edit')}><Edit fontSize="small"/></IconButton>
                <IconButton aria-label="supprimer" onClick={()=>manage_dialog(true, 'delete')}><Delete fontSize="small"/></IconButton>
            </Stack>
            {props.especesUpdates.some(es=>es.montant===props.montant)&&<>
                <ArrowDownward/>
                <Stack direction='row' alignItems='center' spacing={1} alignSelf='center'>
                    <Typography variant="subtitle1" align="center">{props.especesUpdates.find(es=>es.montant===props.montant).updatedCount} x {props.montant.toFixed(2)}€</Typography>
                    <IconButton aria-label="supprimer" onClick={props.deleteUpdate}><Delete sx={{color:'black'}} fontSize="small"/></IconButton>
                </Stack>
            </>}
        </Stack>}

        <Dialog open={open} onClose={()=>manage_dialog(false)} maxWidth='xs' sx={{display:'flex', flexDirection:'column'}}>
        <IconButton aria-label="fermer" onClick={()=>manage_dialog(false)} sx={{alignSelf:'end', margin:0.5}}><Close fontSize="small"/></IconButton>
            {action==='edit'&&<Box display='flex' flexDirection='column' alignItems='center' paddingBottom={2} paddingInline={1}>
                <Stack direction='row' spacing={2} alignItems='center' justifyContent='center' marginBottom={1.5}>
                    <TextField type="number" value={count} onFocus={()=>{if(count===0)setCount('')}} 
                    onChange={e=>setCount(Number(e.target.value))} size="small" sx={{minWidth:'80px', width:'25%'}}/>
                    <Typography variant="subtitle1">{props.montant<5?'pièce(s)':'billet(s)'} de {props.montant.toFixed(2)}€</Typography>
                </Stack>
                <Button variant="contained" onClick={()=>{props.setItem(count); manage_dialog(false)}}>valider</Button>
            </Box>}
            {action==='delete'&&<Box display='flex' flexDirection='column' alignItems='center' paddingBottom={3} paddingInline={3}>
                <Typography variant="h6" fontWeight='bold' align="center">Supprimer {props.count} {props.montant<5?'pièce':'billet'}{props.count>1&&'s'} de {props.montant.toFixed(2)}€</Typography>
                <Stack direction='row' spacing={2} alignItems='center' alignSelf='center' marginTop={2}>
                    <Button onClick={()=>manage_dialog(false,'')} sx={{fontWeight:'bold'}}>annuler</Button>
                    <Button variant="contained" color="carmine" onClick={()=>{props.setItem(0); manage_dialog(false)}}>supprimer</Button>
                </Stack>
            </Box>}
        </Dialog>
    </Box>
}

function AddEspeces(props) {
    const [montant, setMontant] = useState(props.montant??'')
    const [count, setCount] = useState(props.count??0)

    return <Box display='flex' flexDirection='column' alignItems='center' paddingInline={2} marginBottom={3}>
        <Stack direction='row' spacing={2} alignItems='center' marginBottom={2}>
            <TextField select label='monnaie' value={montant} onChange={e=>setMontant(old=>{if(old!==e.target.value)setCount(1);return e.target.value})} fullWidth>
                {props.monnaies.map(mn=><MenuItem key={mn} value={mn}>{mn.toFixed(2)} €</MenuItem>)}
            </TextField>
            <TextField type="number" value={count} label='quantité' fullWidth onFocus={()=>{if(count===0)setCount('')}} onChange={e=>setCount(e.target.value)}/>
        </Stack>
        <Button variant="contained" onClick={()=>{props.add({montant, count:0, updatedCount:count}); props.close()}}>valider</Button>
    </Box>
}

function ChequesItem(props) {
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('') 
    const [num_cheque, setNum] = useState(props.cheque.num_cheque??'')
    const [banque, setBanque] = useState(props.cheque.banque??'')
    const [montant, setMontant] = useState(props.cheque.montant??'')

    const update = useMemo(()=>props.chequesUpdates.find(ch=>ch.old===props.cheque),[props.chequesUpdates, props.cheque])

    function manage_dialog(open, action) {
        setOpen(open)
        setAction(open?action:'')
        if(!open) reset()
    }

    function reset() {
        setNum(props.cheque.num_cheque??'')
        setBanque(props.cheque.banque??'')
        setMontant(props.cheque.montant??'')
    }

    return <Box>
        {props.chequesUpdates.some(ch=>ch.old===props.cheque&&!ch.num_cheque&&!ch.banque&&!ch.montant)?
        <Stack direction='row' alignItems='center' sx={{backgroundColor: 'carmine.background', borderRadius:3, padding:2}}>
            <Box>
                <Typography align="center">N°{props.cheque.num_cheque}</Typography>
                <Typography align="center" textTransform='capitalize'>{props.cheque.banque}</Typography>
                <Typography align="center">{props.cheque.montant.toFixed(2)}€</Typography>
            </Box>
            <IconButton aria-label="supprimer" onClick={()=>{props.deleteUpdate(); reset()}}><Replay fontSize="small"/></IconButton>
        </Stack>
        :<Stack direction='column' alignItems='center' sx={{backgroundColor: 'primary.background', borderRadius:3, padding:2}}>
            <Stack direction='row' alignItems='center'>
                <Box>
                    <Typography align="center">N°{props.cheque.num_cheque}</Typography>
                    <Typography align="center" textTransform='capitalize'>{props.cheque.banque}</Typography>
                    <Typography align="center">{props.cheque.montant.toFixed(2)}€</Typography>
                </Box>
                <IconButton aria-label="modifier" onClick={()=>manage_dialog(true, 'edit')}><Edit fontSize="small"/></IconButton>
                <IconButton aria-label="supprimer" onClick={()=>manage_dialog(true, 'delete')}><Delete fontSize="small"/></IconButton>
            </Stack>
            {props.chequesUpdates.some(ch=>ch.old===props.cheque)&&<>
                <ArrowDownward/>
                <Stack direction='row' alignItems='center' spacing={1} alignSelf='center'>
                    <Box>
                        <Typography fontWeight='bold' align="center">N°{update.num_cheque}</Typography>
                        <Typography fontWeight='bold' align="center" textTransform='capitalize'>{update.banque}</Typography>
                        <Typography fontWeight='bold' align="center">{update.montant.toFixed(2)}€</Typography>
                    </Box>
                    <IconButton aria-label="supprimer" onClick={()=>{props.deleteUpdate(); reset()}}><Delete sx={{color:'black'}} fontSize="small"/></IconButton>
                </Stack>
            </>}
        </Stack>}

        <Dialog open={open} onClose={()=>manage_dialog(false)} maxWidth='xs' sx={{display:'flex', flexDirection:'column'}}>
        <IconButton aria-label="fermer" onClick={()=>manage_dialog(false)} sx={{alignSelf:'end', margin:0.5}}><Close fontSize="small"/></IconButton>
            {action==='edit'&&<Box display='flex' flexDirection='column' alignItems='center' paddingBottom={2} paddingInline={2} rowGap={2}>
                <TextField fullWidth label='N° chèque' value={num_cheque} onChange={e=>setNum(e.target.value)}/>
                <Stack direction='row' spacing={2} alignItems='center' justifyContent='center' marginBottom={1.5}>
                    <TextField select label='Banque' value={banque} onChange={e=>setBanque(e.target.value)} fullWidth>
                        {banques.map(bq=><MenuItem key={bq} value={bq} sx={{textTransform:'capitalize'}}>{bq}</MenuItem>)}
                    </TextField>
                    <TextField type="number" fullWidth label='Montant' value={montant} onFocus={()=>{if(montant===0)setMontant('')}}
                    onChange={e=>setMontant(e.target.value)}/>
                </Stack>
                <Button variant="contained" onClick={()=>{props.setItem({num_cheque, banque, montant: Number(montant)}); manage_dialog(false)}}>valider</Button>
            </Box>}
            {action==='delete'&&<Box display='flex' flexDirection='column' alignItems='center' paddingBottom={3} paddingInline={3}>
                <Typography variant="h6" fontWeight='bold' align="center">Supprimer le chèque {props.cheque.banque} N°{props.cheque.num_cheque} de {props.cheque.montant.toFixed(2)}€</Typography>
                <Stack direction='row' spacing={2} alignItems='center' alignSelf='center' marginTop={2}>
                    <Button onClick={()=>manage_dialog(false,'')} sx={{fontWeight:'bold'}}>annuler</Button>
                    <Button variant="contained" color="carmine" onClick={()=>{props.setItem({}); manage_dialog(false)}}>supprimer</Button>
                </Stack>
            </Box>}
        </Dialog>
    </Box>
}

function AddCheque(props) { 
    const [num_cheque, setNum] = useState(props.num_cheque??'')
    const [banque, setBanque] = useState(props.banque??'')
    const [montant, setMontant] = useState(props.montant??'')

    return <Box display='flex' flexDirection='column' alignItems='center' paddingBottom={2} paddingInline={2} rowGap={2}>
        <TextField fullWidth label='N° chèque' value={num_cheque} onChange={e=>setNum(e.target.value)}/>
        <Stack direction='row' spacing={2} alignItems='center' justifyContent='center' marginBottom={1.5}>
            <TextField select label='Banque' value={banque} onChange={e=>setBanque(e.target.value)} fullWidth>
                {banques.map(bq=><MenuItem key={bq} value={bq} sx={{textTransform:'capitalize'}}>{bq}</MenuItem>)}
            </TextField>
            <TextField type="number" fullWidth label='Montant' value={montant} onFocus={()=>{if(montant===0)setMontant('')}}
            onChange={e=>setMontant(e.target.value)}/>
        </Stack>
        <Button variant="contained" onClick={()=>{props.add({num_cheque, banque, montant: Number(montant)}); props.close()}}>valider</Button>
    </Box>
}

export default function VersWarning(props) {
    const pieces = [500,200,100,50,20,10,5,2,1,0.5,0.2,0.1,0.05,0.02,0.01]
    const {updateConnect} = useContext(Context)
    const agent = JSON.parse(sessionStorage.getItem('user'))
    const [load, setLoad] = useState(false)
    const [especesUpdates, setEsUpdates] = useState([])
    const [chequesUpdates, setChUpdates] = useState([])
    const [message, setMessage] = useState('')
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('') 
    const [edited, setEdit] = useState()

    const especes = useMemo(()=>[...props.vers.fedRepartition?.especes, ...props.vers.fedRepartition?.retrait].filter(es=>es.montant>0&&es.count>0),[props.vers])
    
    function manage_dialog(open, action) {
        setOpen(open)
        setAction(open?action:'')
        if(!open) setEdit()
    }
    
    const handleWarn = (event)=> {
        event.preventDefault()
        const data = {especes: especesUpdates, cheques:chequesUpdates, message}
        setLoad(true)
        fetch(API.concat(`/versement/${props.vers?._id}/alert`), {method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body: JSON.stringify(data)
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const {versement, eglise} = await response.json()
                    versement.eglise = eglise
                    props.setVerses(versement);
                    // props.validate(json._id)
                    props.close()
                } else setLoad(false)
            }
        })
    }

    return(
        <Box display='flex' component='form' onSubmit={handleWarn}  flex={1} flexDirection='column' padding={2}>
            <Typography variant="h5" fontWeight='500' align="center">Signaler une erreur et corriger le bordereau</Typography>
            <Typography variant='h6' fontWeight='bold' marginBottom={2}>Espèces:</Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap' columnGap={3} rowGap={2}>
                {[...new Set(especes.map(es=>es.montant))].map((montant, index)=>{
                    const count = especes.reduce((tt,es)=>tt+(es.montant===montant?es.count:0),0)
                    return <EspecesItem key={index} {...{montant, count, especesUpdates, 
                        setItem:(update)=>setEsUpdates(old=>[...old.filter(es=>es.montant!==montant), {montant, count, updatedCount: update}]), 
                        deleteUpdate:()=>setEsUpdates(old=>old.filter(es=>es.montant!==montant))
                    }}/>
                })}
                {especesUpdates.filter(esu=>esu.count===0).map((es, index)=>
                    <Stack key={index} direction='row' alignItems='center' sx={{border:`solid ${theme.palette.primary.main} 2px`, borderRadius:3, padding:2}}>
                        <Typography marginRight={1}>{es.updatedCount} x {es.montant.toFixed(2)}€</Typography>
                        <IconButton aria-label="modifier" onClick={()=>{setEdit(es);manage_dialog(true, 'edit_especes')}}><Edit fontSize="small"/></IconButton>
                        <IconButton aria-label="supprimer" onClick={()=>setEsUpdates(old=>old.filter(it=>it.montant!==es.montant))}><Delete fontSize="small"/></IconButton>
                    </Stack>
                )}
                <Button variant="contained" onClick={()=>manage_dialog(true,'add_especes')}>ajouter</Button>
            </Stack>
            
            <Typography variant='h6' fontWeight='bold' marginBlock={2}>Chèques:</Typography>
            <Stack direction='row' alignItems='center' flexWrap='wrap' columnGap={3} rowGap={2} marginBottom={3}>
                {props.vers.fedRepartition?.cheques.sort((a,b)=>b.montant-a.montant).map((cheque,index)=>
                <ChequesItem key={index} {...{cheque, chequesUpdates,
                        setItem:(update)=>setChUpdates(old=>[...old.filter(ch=>ch.old!==cheque), {...update, old:cheque}]), 
                        deleteUpdate:()=>setChUpdates(old=>old.filter(ch=>JSON.stringify(ch.old)!==JSON.stringify(cheque)))
                    }}/>
                )}
                {chequesUpdates.filter(chu=>!chu.old||Object.keys(chu.old).length === 0).map((ch, index)=>
                    <Stack key={index} direction='row' alignItems='center' sx={{border:`solid ${theme.palette.primary.main} 2px`, borderRadius:3, padding:2}}>
                        <Box>
                            <Typography align="center">N°{ch.num}</Typography>
                            <Typography align="center" textTransform='capitalize'>{ch.banque}</Typography>
                            <Typography align="center">{ch.montant.toFixed(2)}€</Typography>
                        </Box>
                        <IconButton aria-label="modifier" onClick={()=>{setEdit(ch);manage_dialog(true, 'edit_cheque')}}><Edit fontSize="small"/></IconButton>
                        <IconButton aria-label="supprimer" onClick={()=>setChUpdates(old=>old.filter(item=>item!==ch))}><Delete fontSize="small"/></IconButton>
                    </Stack>
                )}
                <Button variant="contained" onClick={()=>manage_dialog(true,'add_cheque')}>ajouter</Button>
            </Stack>

            <TextField value={message} onChange={e=>setMessage(e.target.value)} label='Commentaire' required multiline rows={3}/>
            
            <Stack direction='row' spacing={2} marginTop={2} alignSelf='end'>
                <Button onClick={props.close} >annuler</Button>
                <Button variant='contained' type="submit">signaler et encaisser</Button>
            </Stack>

            <Dialog open={open} onClose={()=>manage_dialog(false)} maxWidth='xs' sx={{display:'flex', flexDirection:'column'}}>
                <IconButton aria-label="fermer" onClick={()=>manage_dialog(false)} sx={{alignSelf:'end', margin:0.5}}><Close fontSize="small"/></IconButton>
                {action==='add_especes'&&<AddEspeces {...{monnaies:pieces.filter(mn=>!especes.some(es=>es.montant===mn)&&!especesUpdates.some(es=>es.montant===mn)),
                    add:(toAdd)=>setEsUpdates(old=>[...old, toAdd]), close:()=>manage_dialog(false)
                }} />}
                {action==='edit_especes'&&<AddEspeces {...{montant:edited.montant, count:edited.updatedCount, 
                    monnaies:pieces.filter(mn=>!especes.some(es=>es.montant===mn)&&!especesUpdates.some(es=>es.montant===mn&&es.montant!==edited.montant)),
                    add:(toAdd)=>setEsUpdates(old=>[...old.filter(es=>es.montant!==edited.montant), toAdd]), close:()=>manage_dialog(false)
                }} />}
                {action==='add_cheque'&&<AddCheque {...{add:(toAdd)=>setChUpdates(old=>[...old, toAdd]), close:()=>manage_dialog(false)}} />}
                {action==='edit_cheque'&&<AddCheque {...{montant:edited.montant, num:edited.num, banque: edited.banque,
                    add:(toAdd)=>setChUpdates(old=>[...old.filter(ch=>!(!ch.old&&ch.num===edited.num&&ch.banque===edited.banque&&ch.montant===edited.montant)), toAdd]), close:()=>manage_dialog(false)
                }} />}
            </Dialog>
            
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}